import { Component, OnInit } from '@angular/core';
import { AnnouncementsService, Announcement } from '../../../lib/announcements.service';
import { ModalService } from '../../../lib/modal.service';
import { LogService } from '../../../lib/log.service';
import { AnnouncementEditOrgadminComponent } from './announcement-edit/announcement-edit-orgadmin.component';
import { User } from 'app/models/user';
import { UserService } from 'app/lib/user.service';

@Component({
  selector: 'app-announcements-orgadmin',
  templateUrl: './announcements-orgadmin.component.html',
  styleUrls: ['./announcements-orgadmin.component.scss']
})
export class AnnouncementsOrgadminComponent implements OnInit {
  activeAnnouncements: Announcement[] = [];
  expiredAnnouncements: Announcement[] = [];
  isLoading = true;
  user: User;

  constructor(
    private announcementsService: AnnouncementsService,
    private modalService: ModalService,
    private logService: LogService,
    private userService: UserService,
  ) {
    this.user = this.userService.getUser();
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.loadAnnouncements();
  }

  loadAnnouncements(): void {
    this.isLoading = true;
    if (this.user.primaryOrganization?.id) {
      this.announcementsService.getAnnouncementsByOrgID(this.user.primaryOrganization.id).subscribe(
        (announcementsData) => {
          this.activeAnnouncements = announcementsData.active_announcements;
          this.expiredAnnouncements = announcementsData.expired_announcements;
          this.isLoading = false;
        },
        (error) => {
          this.logService.error(`Error loading announcements: ${error}`);
          this.isLoading = false;
          this.modalService.showAlert('Error', 'Failed to load announcements');
        }
      );
    } else {
      this.isLoading = false;
      this.logService.error('No organization ID found for user');
    }
  }

  doCreate(): void {
    this.modalService.setCloseOnClickAway(false);
    this.modalService.showComponent(AnnouncementEditOrgadminComponent).afterClosed().subscribe(result => {
      if (result) {
        this.loadAnnouncements();
      }
    });
  }

  editAnnouncement(announcement: Announcement): void {
    this.modalService.setCloseOnClickAway(false);
    const modal = this.modalService.showComponent(AnnouncementEditOrgadminComponent, { 
      announcementId: announcement.ID,
      isEditing: true 
    });
    modal.afterClosed().subscribe(result => {
      if (result) {
        this.loadAnnouncements();
      }
    });
  }

  viewAnnouncement(announcement: Announcement): void {
    this.modalService.setCloseOnClickAway(false);
    const modal = this.modalService.showComponent(AnnouncementEditOrgadminComponent, { 
      announcementId: announcement.ID 
    });
    modal.afterClosed().subscribe(result => {
      if (result) {
        this.loadAnnouncements();
      }
    });
  }
} 